export default __webpack_public_path__ + "images/1bcc40140f227b6b6b99b80d0c946454.svg";